import _ from "lodash";
import React from "react";
import { ArrowContainer, Popover } from "@toddle-edu/react-tiny-popover";

//components
import SkeletonLoader from "UIComponents/SkeletonLoader";
import { StudentAlertsWrapper } from "AppComponents/StudentAlerts";

//ds
import { Avatar } from "@toddle-edu/ds-web";
import { colors } from "@toddle-edu/ds-theme";

//scss
import classes from "./StudentListPopover.scss";

const styles = {
  arrowConStyle: { padding: "0px" },
  arrowStyle: {
    right: 1.5,
    borderleft: `10px solid var(--surface-primary-enabled)`,
  },
};

const getArrowStyle = (position, arrowSize = 10) => {
  const positionShift = 1.5; // to expose enough of the background
  const border = `${arrowSize}px solid var(--surface-primary-enabled)`;

  switch (position) {
    case "left":
      return {
        right: positionShift,
        borderLeft: border,
      };
    case "right":
      return {
        left: positionShift,
        borderRight: border,
      };
    case "bottom":
      return {
        top: positionShift,
        borderBottom: border,
      };
    default:
      return {
        bottom: positionShift,
        borderTop: border,
      };
  }
};

const StudentListPopover = React.memo(
  ({
    popOverContainerClasses,
    isLoading = false,
    count = 0,
    studentList,
    containerRef,
    position = [],
  }) => {
    return (
      <Popover
        isOpen={true}
        align={"top"}
        positions={
          !_.isEmpty(position) ? position : [("top", "bottom", "left", "right")]
        }
        reposition={true}
        padding={12}
        containerClassName={popOverContainerClasses}
        onClick={e => e?.stopPropagation()}
        content={({ position, childRect, popoverRect }) => {
          return (
            <ArrowContainer
              position={position}
              childRect={childRect}
              popoverRect={popoverRect}
              arrowSize={10}
              arrowColor="var(--border-secondary)"
            >
              <ArrowContainer
                position={position}
                childRect={childRect}
                popoverRect={popoverRect}
                arrowColor={colors.white}
                arrowSize={10}
                style={styles.arrowConStyle}
                arrowStyle={getArrowStyle(position, 10)}
              >
                <div
                  onClick={e => e?.stopPropagation()}
                  className={classes.outerContainer}
                >
                  <div className={classes.innerContainer}>
                    {isLoading
                      ? _.map(new Array(count), (_, index) => {
                          return (
                            <div key={index} className={classes.loaderCon}>
                              <SkeletonLoader
                                height="24px"
                                width="24px"
                                variant="rectangular"
                              />
                              <SkeletonLoader width="80px" height="8px" />
                            </div>
                          );
                        })
                      : _.map(studentList, student => {
                          const { id, name, alertTypes = [] } = student;

                          return (
                            <div key={id} className={classes.loaderCon}>
                              <Avatar
                                id={id}
                                size={"small"}
                                shape={"square"}
                                name={name}
                                dsVersion={"2.0"}
                                className={classes.avatar}
                              />
                              <StudentAlertsWrapper
                                studentId={id}
                                alertTypes={alertTypes}
                              >
                                {name}
                              </StudentAlertsWrapper>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </ArrowContainer>
            </ArrowContainer>
          );
        }}
        childrenRef={{ current: containerRef.current }}
        isChildrenRefPassed={true}
      />
    );
  }
);

StudentListPopover.displayName = "StudentListPopover";

export default StudentListPopover;
